import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import MetaTags from "react-meta-tags";

import useMapData from "./utils/useMapData";

import Home from "./pages/Home";

import { ModalContextProvider } from "./context/ModalContext";

import { ThemeProvider } from "styled-components";

const defaultTitle = "Prowin properties";
const defaultDescription = "Prowin properties description";
const defaultOGURL = "https://www.prowinproperties.com/";

const AppRoutes = () => {
  const { pathname } = useLocation();
  let propertyId = pathname.replace("/", "");
  const resultList = useMapData(propertyId);

  const theme = {
    main: resultList.themeColor,
  };

  return (
    <>
      <MetaTags>
        <title>{resultList?.metaData?.title || defaultTitle}</title>
        <link rel="icon" href={resultList?.metaData?.favicon} />
        <meta name="theme-color" content={resultList?.metaData?.themeColor} />
        <meta
          property="og:url"
          content={resultList?.metaData?.canonical || defaultOGURL}
        />
        <meta
          property="og:title"
          content={resultList?.metaData?.title || defaultTitle}
        />
        <meta
          property="og:description"
          content={resultList?.metaData?.description || defaultDescription}
        />
      </MetaTags>
      <ThemeProvider theme={theme}>
        <ModalContextProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/:propertyId" element={<Home />} />
          </Routes>
        </ModalContextProvider>
      </ThemeProvider>
    </>
  );
};

export default AppRoutes;
